import { render, staticRenderFns } from "./FacetFilter.vue?vue&type=template&id=1b2df052&"
import script from "./FacetFilter.vue?vue&type=script&lang=js&"
export * from "./FacetFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports